import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import {of, Subject} from 'rxjs';
import * as DialogActions from 'app/dialog/features/dialog.actions';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService
  ) {
  }

  getAllEvents() {
    const token = this.cookieService.get('accessToken');
    return this.http.post('/api/allevents/get/all', `access_token=${token}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  createEvent(event) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(event))}`
    ];
    return this.http.post('/api/event/create', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getSimpleAudianceMonitorsAll(params){
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];

    return this.http.post('api/am/manage/get/all', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  createSimpleAudianceMonitor(params) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];
    return this.http.post('/api/am/manage/create', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateSimpleAudianceMonitor(params) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];
    return this.http.post('/api/am/manage/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  deleteSimpleAudianceMonitor(id, activate){
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({id,activate}))}`,
    ];
    return this.http.post('/api/am/manage/delete', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  generateConfirmAction(name, initialState) {
    return DialogActions.openDialog({
      payload: {
        name,
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-sm',
          containerClass:'mdb-modal-backdrop-paybee',
          ignoreBackdropClick: true
        },
        initialState
      }
    });
  }

  createVEvent(event) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(event))}`
    ];
    return this.http.post('/api/vevent/create', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  createHEvent(event) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(event))}`
    ];
    return this.http.post('/api/hevent/create', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateEvent(event) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(event))}`
    ];
    return this.http.post('/api/event/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateVEvent(event) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(event))}`
    ];
    return this.http.post('/api/vevent/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateHEvent(event) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(event))}`
    ];
    return this.http.post('/api/hevent/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  upgradeEvent(eventParams){
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(eventParams))}`
    ];

    return this.http.post('/api/hevent/upgrade', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  copyEvent(eventParams,type) {
    const token = this.cookieService.get('accessToken');
    let link = null;
    switch(type){
      case 0 :
          link =`/api/event/clone`
          break
      case 1 :
          link='/api/vevent/clone'
          break
      case 2 :
          link='/api/hevent/clone'
          break
  }
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(eventParams))}`
    ];
    return this.http.post(link, _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  deleteEvent(eventId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `eventId=${eventId}`
    ];
    return this.http.post('/api/event/delete', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  deleteVEvent(eventId, deleteValue) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `delete=${deleteValue}`,
      `id=${eventId}`
    ];
    return this.http.post('/api/vevent/delete', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  deleteHEvent(eventId, deleteValue) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `delete=${deleteValue}`,
      `eventId=${eventId}`
    ];

    return this.http.post('/api/hevent/delete', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  resetVEvent(eventId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `vEventId=${eventId}`
    ];
    return this.http.post('/api/vevent/reset', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getEventConfig(data) {
    const queryParams = [
      `p=${encodeURIComponent(JSON.stringify(data))}`
    ];

    return this.http.post('/api/eventPage/get', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  addEventPageBlock(data) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(data))}`
    ];

    return this.http.post('api/eventPage/block/add', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateEventPageBlock(data) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(data))}`
    ];

    return this.http.post('api/eventPage/block/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  removeEventPageBlock(data) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(data))}`
    ];

    return this.http.post('api/eventPage/block/delete', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateEventConfigPage(data) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(data))}`
    ];

    return this.http.post('api/eventPage/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  addToCart(data) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(data))}`
    ];

    return this.http.post('api/vevent/addToCart', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  addRegistration(data) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(data))}`
    ];

    return this.http.post('api/eventPage/registration/add', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  removeRegistration(data) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(data))}`
    ];

    return this.http.post('api/eventPage/registration/delete', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateRegistration(data) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(data))}`
    ];

    return this.http.post('api/eventPage/registration/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  createStream(event) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(event))}`
    ];
    return this.http.post('/api/stream/create', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getAllStreams() {
    const token = this.cookieService.get('accessToken');
    return this.http.post('/api/stream/all/get', `access_token=${token}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getVideoDownloadUrl(data) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `recordingId=${data.recordingId}`,
      `streamName=${data.streamId}`
    ];
    // `p=${encodeURIComponent(JSON.stringify(data))}`

    return this.http.post('/api/stream/recording/get', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }
}
